import { createFileRoute } from '@tanstack/react-router';
import { ZoneTable } from '@/components/Pages/Zones/ZoneTable';
import { CreateEditZoneModal } from '@/components/Pages/Zones/CreateEditZoneModal';
import { Box } from '@mui/joy';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/zones')({
  component: ZonesPage,
});

function ZonesPage() {
  const { isAdmin, isSuperAdmin } = useAuth();
  const showActions = isAdmin || isSuperAdmin;

  return (
    <Box>
      {showActions && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
          <CreateEditZoneModal />
        </Box>
      )}
      <ZoneTable />
    </Box>
  );
}
